import React, { useState } from "react";
import { Modal, Input, Form } from "antd";
function MyBooking() {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => setIsModalVisible(true);

  const handleCancel = () => setIsModalVisible(false);

  const onFinish = (values) => {
    console.log('succes:', values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  return (
    <div className="modalBox">
      <button onClick={showModal}>Đặt phòng của tôi</button>
      <Modal
        destroyOnClose={true}
        title="My Booking"
        className="popupMyBooking modalStyle"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}>
          <p>Enter booking code to see more booking detail</p>
          <Form.Item className="formInput"
            label="BOOKING CODE"
            name="bookingcode"
            rules={[
              {
                required: true,
                message: 'Trường không được bỏ trống',
              }
            ]}
          >
            <Input
              type="text"
              placeholder="Enter booking code"
            />
          </Form.Item>
          <Form.Item className="formInput"
            label="EMAIL / PHONE NUMBER"
            name="emai_phone"
            rules={[
              {
                required: true,
                message: 'Trường không được bỏ trống',
              }
            ]}
          >
            <Input
              type="text"
              placeholder="Enter email/phone number"
            />
          </Form.Item>
          <Form.Item className="btnModal">
            <button className="btnStyle">
              Enter
            </button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
export default MyBooking;
